export default __webpack_public_path__ + "static/media/moscow.58b33ed2.png";